import { ControlledTextInput } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';

export const BirthPlace: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const validate = useValidateOnBlur(type);

  return (
    <ControlledTextInput
      {...props}
      name={type}
      type="text"
      onBlur={validate}
    />
  );
};
